import { render, staticRenderFns } from "./DemandList.vue?vue&type=template&id=4b5e4b7a&scoped=true&"
import script from "./DemandList.vue?vue&type=script&lang=js&"
export * from "./DemandList.vue?vue&type=script&lang=js&"
import style0 from "./DemandList.vue?vue&type=style&index=0&id=4b5e4b7a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5e4b7a",
  null
  
)

export default component.exports